import type {
  InputControlState,
  InputControlStateInput,
} from 'ui/forms/input-control/input-control.types';

export const getInputControlState = ({
  id,
  disabled,
  error,
  errorMessage,
  supportiveText,
  helperText,
}: InputControlStateInput): InputControlState => {
  const isError = !disabled && (!!error || !!errorMessage);
  const supportiveTextId = supportiveText ? `${id}-supportive` : undefined;
  const errorMessageId = isError && errorMessage ? `${id}-error` : undefined;
  const helperTextId =
    helperText && !errorMessageId ? `${id}-helper` : undefined;
  const describedBy =
    [supportiveTextId, errorMessageId, helperTextId]
      .filter(Boolean)
      .join(' ') || undefined;

  return {
    isError,
    supportiveTextId,
    errorMessageId,
    helperTextId,
    describedBy,
  };
};
